import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ReportAnswers, ReportAreas, ReportAuditOption, ReportHeader, ReportSummary } from '../models/report.models';
import { AggregateAudit, AggregateLocations } from '../models/report-aggregate.models';

@Injectable({ providedIn: 'root' })
export class ReportsApi {
  private readonly http = inject(HttpClient);
  private readonly base = '/api/bhp/api/reports/audits';

  aggregateAudits(): Observable<{ results: AggregateAudit[] }> {
    return this.http.get<{ results: AggregateAudit[] }>('/api/bhp/api/reports/aggregate/audits/');
  }

  aggregateLocations(auditId: string): Observable<AggregateLocations> {
    return this.http.get<AggregateLocations>(`/api/bhp/api/reports/aggregate/audits/${auditId}/locations/`);
  }

  audits(): Observable<{ results: ReportAuditOption[] }> {
    return this.http.get<{ results: ReportAuditOption[] }>(`${this.base}/`);
  }

  answers(option: ReportAuditOption, iterations = 7, comparison?: string): Observable<ReportAnswers> {
    let params = new HttpParams().set('location_id', option.location_id).set('iterations', iterations);
    if (comparison) params = params.set('compare_execution_plan_id', comparison);
    return this.http.get<ReportAnswers>(`${this.base}/${option.audit_id}/answers/`, { params });
  }

  summary(option: ReportAuditOption, iterations = 7): Observable<ReportSummary> {
    const params = new HttpParams().set('location_id', option.location_id).set('iterations', iterations);
    return this.http.get<ReportSummary>(`${this.base}/${option.audit_id}/summary/`, { params });
  }

  header(option: ReportAuditOption, iterations = 7, comparison?: string): Observable<ReportHeader> {
    let params = new HttpParams().set('location_id', option.location_id).set('iterations', iterations);
    if (comparison) params = params.set('compare_execution_plan_id', comparison);
    return this.http.get<ReportHeader>(`${this.base}/${option.audit_id}/header/`, { params });
  }

  areas(option: ReportAuditOption, iterations = 7, comparison?: string): Observable<ReportAreas> {
    let params = new HttpParams().set('location_id', option.location_id).set('iterations', iterations);
    if (comparison) params = params.set('compare_execution_plan_id', comparison);
    return this.http.get<ReportAreas>(`${this.base}/${option.audit_id}/areas/`, { params });
  }
}
